/**
 * @description 加油包特权列表
 * @author Kody
 * @date 2019-08-05
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

import IOutput from './models/output';

export const getPrivilegeList = (): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_PRIVILEGE_LIST)
        .then((res: IListResponse<IOutput>) => {
            return res.data;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'getPrivilegeList',
                additionalInfo: {
                    description: 'getPrivilegeList fetchData error',
                },
            });
            throw err;
        });
};
